// extracted by mini-css-extract-plugin
export default {"timers":"Timer_timers__0Njlf","colons":"Timer_colons__ka5e7","numbers":"Timer_numbers__ABLE1"};